import { styled } from '@mui/material/styles';

import Modal from 'src/presentations/components/molecules/modal';
import { CircularProgress, Button } from '@mui/material';
import { useUploadModalSelector } from './UploadModalSelector';
import { useInvoiceContext } from '../InvoiceContextProvider';
import { useShipmentSelector } from '../ShipmentSelector';
import { UCTInputUploadDocument } from './Input';

const StyledModal = styled(Modal)(({ theme }) => ({
  '& .MuiDialog-paper': {
    maxWidth: '62.5rem',
    height: 'auto',
    borderRadius: '1rem',
    [theme.breakpoints.down(1520)]: {
      maxWidth: '50rem',
    },

    '& .MuiDialogContent-root': {
      padding: '1.25rem 0',
      display: 'flex',
      flexDirection: 'column',
    },
  },
}));

export const UploadModal = () => {
  const { isShowModal, isLoadingUpload, closeUpload } = useUploadModalSelector();
  const { invoiceSummary } = useInvoiceContext();
  const { shipment } = useShipmentSelector();

  return (
    <StyledModal open={isShowModal} onClose={closeUpload} fullWidth maxWidth='md'>
      {isShowModal && (
        <>
          {isLoadingUpload ? (
            <div className='p-48 flex items-center justify-center'>
              <CircularProgress color='primary' />
            </div>
          ) : (
            <>
              <div className='px-24 pt-10 pb-10'>
                <h2 className='text-18 xl:text-24  leading-28 xl:leading-30 mb-6 xl:mb-8 font-bold'>Upload Missing or Additional Documents</h2>
                <div className='flex items-center gap-12 text-12 xl:text-14 leading-18 text-blue_grey-80'>
                  <div>
                    Invoice No. <strong className='text-primary'>{invoiceSummary?.invoiceNumber}</strong>
                  </div>
                  <div className='w-1 h-14 bg-neutral-20' />
                  <div>
                    <strong className='text-primary'>{shipment?.shipmentDetail?.shipmentNumber}</strong>
                  </div>
                </div>
              </div>

              <div className='px-24 pt-32 pb-48'>
                <UCTInputUploadDocument invoiceSummary={invoiceSummary} attachmentType='RATE_CARD' isPreview={false} />
              </div>

              <div className='mt-auto px-24 py-20 border-t border-neutral-20 flex items-center'>
                <Button type='button' variant='outlined' color='inherit' onClick={closeUpload} sx={{ textTransform: 'capitalize' }}>
                  Close
                </Button>
                <Button type='button' variant='contained' color='primary' onClick={closeUpload} sx={{ textTransform: 'capitalize', ml: 'auto' }}>
                  Save
                </Button>
              </div>
            </>
          )}
        </>
      )}
    </StyledModal>
  );
};
